import { z } from 'zod';

import {
    estimatedMonthlyTransactionValues,
    estimatedMonthlyTransactionVolumes,
    initialEstimatedMonthlyTransactionCurrency,
} from '../resources/constants';
import { messages } from './messages';

export const schema = z
    .object({
        accountUsage: z
            .object({
                estimatedMonthlyTransactionCurrency: z.string().default(initialEstimatedMonthlyTransactionCurrency),
                estimatedMonthlyTransactionVolume: z
                    .enum(estimatedMonthlyTransactionVolumes, { required_error: messages.requiredField })
                    .transform((value) => +value),
                estimatedMonthlyTransactionValue: z
                    .enum(estimatedMonthlyTransactionValues, { required_error: messages.requiredField })
                    .transform((value) => +value),
            })
            .passthrough(),
    })
    .passthrough();
